import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';

const RentWizard = lazy(() => import(/* webpackChunkName: "RentWizard" */ './components/RentWizard'));

const rentWizard = document.getElementById('rent-wizard');
if (rentWizard != null) {
    const props = {};

    // Parse dataset to valid props
    for (const key in rentWizard.dataset) {
        props[key] = rentWizard.dataset[key];

        // Try to parse string to literal
        // Will parse: array, boolean, null, number, object and string
        try {
            props[key] = JSON.parse(props[key]);
        } catch (e) { } // eslint-disable-line no-empty
    }

    render(
        <Suspense fallback={<></>}>
            <RentWizard
                {...props}
            />
        </Suspense>,
        rentWizard
    );
}
